/* eslint-disable no-empty-pattern */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */

import apiIntegracaoOito from '@services/apiIntegracaoOito';

async function fetchAuthOito(): Promise<any> {
    const tokenLatitude =
        process.env.NEXT_PUBLIC_TOKEN_PARCEIRO_OITO || '63A3B459-2876-46E2-BBFA-0AB3D56DA071';
    const headers = {
        'Content-Type': 'application/json',
    };

    const responseData = await apiIntegracaoOito
        .post(`.authToken`, tokenLatitude, { headers })
        .then((res: any) => {
            return res.data || [];
        });

    return responseData;
}

export default fetchAuthOito;
